import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

import ParticipantsSection from "./ParticipantsSection";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";

// Reusable Input Field Component
const InputField = React.memo(
  ({
    label,
    value,
    handleChange,
    placeholder,
    multiline = false,
    rows = 1,
  }) => (
    <Grid
      item
      lg={multiline ? 6 : 3}
      md={multiline ? 6 : 3}
      sm={multiline ? 12 : 6}
      xs={12}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          variant="subtitle2"
          component="label"
          sx={{ marginBottom: "10px" }}
        >
          {`${label} :`}
        </Typography>
        <FormControl size="small" fullWidth>
          <TextField
            placeholder={placeholder}
            size="small"
            value={value}
            onChange={(e) => handleChange(label.toLowerCase(), e.target.value)}
            multiline={multiline}
            rows={rows}
          />
        </FormControl>
      </Box>
    </Grid>
  )
);

const EventForm = React.memo(
  ({
    eventDetails,
    handleChange,
    classes,
    playerData,
    participants,
    activeView,
    showParticipants,
    toggleParticipants,
    handleToggle,
    addParticipant,
    searchPlayerOrCollegeName,
    playerNameSearchText,
    handleOnSaveAction,
    editMode,
    commonEventList,
    eventRosterID,
    setEventRosterID,
    loading,
    setParticipants,
    handleDateChange,
    handleEndDateChange,
    handleSelectAllParticipant,
  }) => (
    <Grid container spacing={3}>
      <EventDatePicker
        label="Event Start Date & Time"
        value={eventDetails.eventStartDateTime}
        handleChange={handleDateChange}
        classes={classes}
      />
      <EventDatePicker
        label="Event End Date & Time"
        value={eventDetails.eventEndDateTime}
        handleChange={handleEndDateChange}
        classes={classes}
      />
      <InputField
        label="Title"
        value={eventDetails.title}
        handleChange={handleChange}
        placeholder="Please enter a title"
      />
      <InputField
        label="Location"
        value={eventDetails.location}
        handleChange={handleChange}
        placeholder="Please enter a location"
      />
      <InputField
        label="Description"
        value={eventDetails.description}
        handleChange={handleChange}
        placeholder="Please enter a description"
        multiline
        rows={4}
      />
      <PublishCheckbox
        eventDetails={eventDetails}
        handleChange={handleChange}
      />
      <ParticipantsSection
        {...{
          classes,
          handleToggle,
          activeView,
          showParticipants,
          toggleParticipants,
          addParticipant,
          searchPlayerOrCollegeName,
          playerNameSearchText,
          playerData,
          participants,
          commonEventList,
          eventRosterID,
          setEventRosterID,
          setParticipants,
          eventDetails,
          editMode,
          loading,
          eventDetails,
          handleOnSaveAction,
          handleSelectAllParticipant,
        }}
      />
      {/* <SaveButtons
        classes={classes}
        handleOnSaveAction={handleOnSaveAction}
        editMode={editMode}
        eventDetails={eventDetails}
        loading={loading}
      /> */}
    </Grid>
  )
);

const EventDatePicker = React.memo(
  ({ label, value, handleChange, classes }) => (
    <Grid item lg={3} md={3} sm={12} xs={12}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          variant="subtitle2"
          component="label"
          sx={{ marginBottom: "10px" }}
        >
          {label} :
        </Typography>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateTimePicker
            label={label}
            value={value}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} />}
            slotProps={{ textField: { size: "small" } }}
          />
        </LocalizationProvider>
      </Box>
    </Grid>
  )
);

const PublishCheckbox = React.memo(({ eventDetails, handleChange }) => (
  <Grid item lg={6} md={6} sm={6} xs={12}>
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={eventDetails.publish}
            onChange={(e) => handleChange("publish", e.target.checked)}
          />
        }
        label="Publish"
      />
    </Box>
  </Grid>
));

const SaveButtons = React.memo(
  ({ classes, handleOnSaveAction, editMode, eventDetails, loading }) => (
    <Grid item lg={12}>
      <Box className={classes.buttonContainer}>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="primary"
            loading={loading}
            loadingPosition="end"
            startIcon={editMode ? <EditIcon /> : <AddCircleIcon />}
            onClick={() => handleOnSaveAction(eventDetails.eventId || 0)}
            disabled={loading}
          >
            Save
          </Button>
        </Stack>
      </Box>
    </Grid>
  )
);

export default EventForm;
